var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBodyPart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2,.cls-3,.cls-4{stroke:#FF6158;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;fill:none}.cls-4{opacity:0.2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60,33s-11-9-20,3c0,0-8-7-17,0L22,19s-.44-.61-1.13-1.49l.55.06s3.54,0,4.13-1.32l2,1.81a1.88,1.88,0,0,0,2.61-.19L35,12.41a1.88,1.88,0,0,0,.12-2.36L29.69,3,13.74,10.28A1.49,1.49,0,0,0,13,11c-1,3-9,32-9,34v2.32a1.4,1.4,0,0,0,.53,1.1C5,48.76,7.12,49.36,8,50c3.77,2.76,9.65,7.59,16,9,9,2,20-1,20-1a28.79,28.79,0,0,0,16,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21,40s1,0,2-4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43,41s0-2-3-5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54,48s0,2,6,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16,47s6,10,20,7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyPart);
export default __webpack_public_path__ + "static/media/bodyPart.b4d80a102abe3d6ed2b14b12ee2a8521.svg";
export { ForwardRef as ReactComponent };